/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Exhaustairtemperaturedefect3Inputs */



/**
* | output |
* | --- |
* | "Exhaust air temperature sensor fault" |
*
* @param {Ahu_History_Key_Exhaustairtemperaturedefect3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_exhaustairtemperaturedefect3 = /** @type {((inputs?: Ahu_History_Key_Exhaustairtemperaturedefect3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Exhaustairtemperaturedefect3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Exhaust air temperature sensor fault")
	return /** @type {LocalizedString} */ ("Défaut sonde température air rejeté")
});
export { ahu_history_key_exhaustairtemperaturedefect3 as "ahu_history_key_exhaustAirTemperatureDefect" }